customElements.get("quick-add-modal") || customElements.define("quick-add-modal", class e extends ModalDialog {
    constructor() {
        super(), this.modalContent = this.querySelector('[id^="QuickAddInfo-"]')
    }
    hide(e = !1) {
        let t = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy), this.modalContent.innerHTML = "", e && (this.openedBy = null), super.hide()
    }
    show(e) {
        e.setAttribute("aria-disabled", !0), fetch(e.getAttribute("data-product-url")).then(e => e.text()).then(t => {
            let r = (new DOMParser).parseFromString(t, "text/html");
            this.productElement = r.querySelector('section[id^="MainProduct-"]'), this.preventDuplicatedIDs(), this.removeDOMElements(), this.setInnerHTML(this.modalContent, this.productElement.innerHTML), window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), window.ProductModel && window.ProductModel.loadShopifyXR(), this.removeGalleryListSemantic(), this.updateImageSizes(), this.preventVariantURLSwitching(), super.show(e)
        }).finally(() => {
            e.removeAttribute("aria-disabled")
        })
    }
    setInnerHTML(e, t) {
        e.innerHTML = t, e.querySelectorAll("script").forEach(e => {
            let t = document.createElement("script");
            Array.from(e.attributes).forEach(e => {
                t.setAttribute(e.name, e.value)
            }), t.appendChild(document.createTextNode(e.innerHTML)), e.parentNode.replaceChild(t, e)
        })
    }
    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }
    removeDOMElements() {
        let e = this.productElement.querySelector("pickup-availability");
        e && e.remove();
        let t = this.productElement.querySelector("product-modal");
        t && t.remove()
    }
    preventDuplicatedIDs() {
        let e = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(e, `quickadd-${e}`), this.productElement.querySelectorAll("variant-selects, variant-radios").forEach(t => {
            t.dataset.originalSection = e
        })
    }
    removeGalleryListSemantic() {
        let e = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        e && (e.setAttribute("role", "presentation"), e.querySelectorAll('[id^="Slide-"]').forEach(e => e.setAttribute("role", "presentation")))
    }
    updateImageSizes() {
        let e = this.modalContent.querySelector(".product"),
            t = e.classList.contains("product--columns");
        if (!t) return;
        let r = e.querySelectorAll(".product__media img");
        if (!r.length) return;
        let i = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        e.classList.contains("product--medium") ? i = i.replace("715px", "605px") : e.classList.contains("product--small") && (i = i.replace("715px", "495px")), r.forEach(e => e.setAttribute("sizes", i))
    }
});